import { Injectable } from '@angular/core';
import { Toggle } from './toggle';
import { Observable, of} from 'rxjs';
import { api,  retryStrategy } from '../../shared/api-loaders';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {  retryWhen, map, catchError  } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ToggleService {

  constructor(private http: HttpClient) { }

  private $cacheToggles: Toggle;

  private toggles = {
    "bp.idm.azuread.enabled": "azureADEnabled",
    "bp.idm.federation.id.enabled":"federatedLoginIdEnabled",
    "provision.sharedcomponents.launcher.enabled": "launcherEnabled",
    "bp.idm.scim.enabled": "scimEnabled",
    "multicare.mobile.enabled": "multicareMobileEnabled"
  }

  get(): Observable<Toggle> {

    if (this.$cacheToggles)
      return of(this.$cacheToggles);

    return this.http
      .get<any[]>(api.toggles()).pipe(
        map((x) => {
          var t = new Toggle();

          for (let item of x) {
            let mappedName = this.toggles[item.name];
            if (mappedName)
              t[mappedName] = item.enabled;
            else {
              console.error(`${item.name} not found on ToggleService.toggles. Using it as the name`)
              t[item.name] = item.enabled;
            }
          }

          this.$cacheToggles = t;
          return t;
        }),
        retryWhen(retryStrategy()),
        catchError((err) => {
          // If toggles endpoint fails (e.g., 401), return safe defaults so UI can continue
          console.warn('ToggleService.get failed; returning defaults.', err);
          const t = new Toggle();
          this.$cacheToggles = t; // cache defaults to avoid repeated failing calls
          return of(t);
        })
      );
  }

}
